import React from 'react';
import FeatureTimelinePage from '../FeatureTimelinePage';

/** OthersLayout > Timeline — reuses FeatureTimelinePage in embedded mode so
 *  the outer chrome (PageHeader, StandardLayout) is owned by OthersLayout. */
const TimelineSection: React.FC = () => <FeatureTimelinePage embedded />;

export default TimelineSection;
